define(['jquery', 'auth'], function ($, auth) {

    Number.prototype.formatMoney = function (c, d, t) {
        var n = this,
            s = n < 0 ? "-" : "",
            i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
            j = (j = i.length) > 3 ? j % 3 : 0;

        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d === undefined ? "." : d;
        t = t === undefined ? "," : t;

        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };

    var _internals = {
        getCookie: function (name) {
            var cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = jQuery.trim(cookies[i]);
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        initAjax: function () {
            $.ajaxPrefilter(function (options) {
                if (!options.beforeSend) {
                    options.beforeSend = function (xhr) {
                        xhr.setRequestHeader("X-XSRF-Token", _internals.getCookie("XSRF-TOKEN"));
                    }
                }
            });
        },
        initRaven: function () {
            require(['https://cdn.ravenjs.com/3.14.1/raven.min.js'], function (Raven) {
                Raven.config(window.sentry_dsn, window.sentry_options).install();
                if (window.raven_user_context !== null) {
                    Raven.setUserContext(window.raven_user_context);
                }
            });
        },
        loadFonts: function () {
            require(['//ajax.googleapis.com/ajax/libs/webfont/1/webfont.js'], function (WebFont) {
                WebFont.load({google: {families: ['PT Sans', 'PT Serif']}});
            });
        },
        initUI: function () {
            require(['modals', 'pagination', 'cart', 'compare', 'mobile-menu'], function (modals, pagination, cart, compare, mMenu) {
                modals.init();
                pagination.init();
                cart.bindToUI();
                compare.bindToUI();
                mMenu.init();
            });
            require(['autocomplete'], function () {
                $('#search-text').autocomplete({
                    serviceUrl: '/api-services/product/search',
                    minChars: 3,
                    deferRequestBy: 200,
                    preventBadQueries: false,
                    triggerSelectOnValidInput: false,
                    onSelect: function (suggestion) {
                        window.location.href = suggestion.data;
                    },
                    formatResult: function (suggestion) {
                        return suggestion.view;
                    }
                });
            });
        }
    };

    return {
        init: function () {
            _internals.initRaven();
            _internals.initAjax();
            auth.init();
        },
        initUI: function () {
            _internals.loadFonts();
            _internals.initUI();
        }
    }
});

function validateEmail(email, validator, $field) {
    var dfd = $.Deferred();

    if (window.validateXHR !== undefined) {
        window.validateXHR.abort();
    }

    window.validateXHR = $.ajax({
        url: $field.data('url'),
        method: 'post',
        data: {
            value: email,
            check: $field.data('check'),
            _token: $field.data('token')
        },
        dataType: 'json',
        success: function (response) {
            dfd.resolve(response);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            dfd.resolve({valid: true, message: ''});
            if (errorThrown !== 'abort') {
                throw new Error('Error validating email. Status: ' + textStatus + ', error: ' + errorThrown + ', response: ' + jqXHR.responseText);
            }
        }
    });

    return dfd.promise();
}
